import { BidPointViewModel, MapObjectModel } from "api";
import { dateToView } from "helpers/date";
import { bidPointTypesEnum, mapObjectTypesEnum } from "helpers/enums";
import compact from "lodash/compact";
import moment from "moment";

export const LOAD_UNLOAD_POINT_ORDER_ERROR =
    "Точка «Загрузка-выгрузка» должна находиться между первой загрузкой и последней выгрузкой";

export const isCargoBidPointType = (type?: string | null) =>
    type === bidPointTypesEnum.LoadPoint ||
    type === bidPointTypesEnum.UnloadPoint ||
    type === bidPointTypesEnum.LoadUnloadPoint;

export const getBidPointCounterpartyLabel = (type?: string | null) => {
    if (type === bidPointTypesEnum.LoadUnloadPoint) {
        return "Грузоотправитель/грузополучатель";
    }
    return type === bidPointTypesEnum.LoadPoint ? "Грузоотправитель" : "Грузополучатель";
};

export const getBidPointLoadOptionsLabel = (type?: string | null) => {
    if (type === bidPointTypesEnum.LoadUnloadPoint) {
        return "Типы погрузки/выгрузки";
    }
    return type === bidPointTypesEnum.LoadPoint ? "Типы погрузки" : "Типы выгрузки";
};

export const isLoadUnloadPointOrderValid = (bidPoints: Array<Pick<BidPointViewModel, "order" | "type">> = []) => {
    const orderedPoints = [...bidPoints].sort((previousPoint, nextPoint) => previousPoint.order - nextPoint.order);
    const firstLoadPointIndex = orderedPoints.findIndex((point) => point.type === bidPointTypesEnum.LoadPoint);
    let lastUnloadPointIndex = -1;

    orderedPoints.forEach((point, index) => {
        if (point.type === bidPointTypesEnum.UnloadPoint) {
            lastUnloadPointIndex = index;
        }
    });

    return orderedPoints.every(
        (point, index) =>
            point.type !== bidPointTypesEnum.LoadUnloadPoint ||
            (index > firstLoadPointIndex && firstLoadPointIndex >= 0 && index < lastUnloadPointIndex),
    );
};

export function getFirstPoint(bidPoints: BidPointViewModel[]) {
    return sortedPoints(bidPoints)[0];
}

export function getLastPoint(bidPoints: BidPointViewModel[]) {
    return sortedPoints(bidPoints)[bidPoints.length - 1];
}

export function sortedPoints(bidPoints: BidPointViewModel[]) {
    return (bidPoints || []).sort((a, b) => (a.order > b.order ? 1 : b.order > a.order ? -1 : 0));
}

export function formatDateTimezone({ planEnterDateOffset }: { planEnterDateOffset: string | number }) {
    if (!(planEnterDateOffset && planEnterDateOffset !== 0)) {
        return null;
    }
    const planEnterDateUtcOffset = moment.parseZone(planEnterDateOffset).format("Z");
    return "(" + planEnterDateUtcOffset + ")";
}

export const getPointTime = (logistTime?: string, autoTime?: string, gpsTime?: string) => {
    const result = logistTime || autoTime || gpsTime;
    if (result) {
        return dateToView(result, "YYYY-MM-DD HH:mm:00");
    } else {
        return result;
    }
};

export function clearDates(
    points: Array<{
        planEnterDate: string | null | undefined;
        planEnterDateOffset: string | null | undefined;
        planLeaveDate: string | null | undefined;
        planLeaveDateOffset: string | null | undefined;
        secondaryPlanEnterDate: string | null | undefined;
        secondaryPlanEnterDateOffset: string | null | undefined;
    }>,
) {
    points.forEach((point) => {
        point.planEnterDate = null;
        point.planEnterDateOffset = null;
        point.secondaryPlanEnterDate = null;
        point.secondaryPlanEnterDateOffset = null;
        if (point.planLeaveDate) {
            point.planLeaveDate = null;
        }
        if (point.planLeaveDateOffset) {
            point.planLeaveDateOffset = null;
        }
    });
}

// county - район
// state - регион
export function getShortAddress(geozone: MapObjectModel, showFullAddress = false) {
    const { city, state, village, county, address } = geozone;
    if (showFullAddress) {
        return [city || village || county, address];
    }
    if (city) {
        return compact([city, state]);
    }
    if (village) {
        return compact([village, county || state]);
    }
    return compact([county, state]);
}

export const withoutStartPoint = (bidPoints: BidPointViewModel[]) =>
    bidPoints?.filter(({ type }) => type !== bidPointTypesEnum.StartPoint);

export const isStartBidPoint = (type: keyof typeof mapObjectTypesEnum) => type === mapObjectTypesEnum.StartBidPoint;

export const isBidPoint = (type: keyof typeof mapObjectTypesEnum) =>
    type === mapObjectTypesEnum.BidPoint || type === mapObjectTypesEnum.CounterpartyPoint;

export const START_POINT_LETTER = "0";
